import { PendingOrderProductKeys } from '../../interfaces/orderProducts.helper.interfaces';
import { OrderProduct, Section, SectionPendencyEnum } from '../../orderProducts.types';
import { hasOrderProductPendency } from '../orderProductsPendency.utils';
import OrderProductsBuilder, { OrderProductsGroupProps } from './OrderProductsGroupBuilder';

class OrderProductsGroupByPendency extends OrderProductsBuilder {
  private sectionWithErrors: Section = {
    products: [],
    productsCount: 0,
    isExpanded: true,
    pendency: SectionPendencyEnum.WITH_PENDENCIES,
  };

  private sectionWithoutErrors: Section = {
    products: [],
    productsCount: 0,
    isExpanded: true,
    pendency: SectionPendencyEnum.WITHOUT_PENDENCIES,
  };

  group({ orderProducts, pendingOrderProductKeys }: OrderProductsGroupProps): Section[] {
    this.groupProductsByPendency(orderProducts, pendingOrderProductKeys);
    return this.getSections();
  }

  private groupProductsByPendency(
    orderProducts: OrderProduct[],
    pendingOrderProductKeys?: PendingOrderProductKeys,
  ) {
    orderProducts.forEach((op) => {
      this.validateOrderProductPendency(op, pendingOrderProductKeys);
    });
  }

  private validateOrderProductPendency(
    op: OrderProduct,
    pendingOrderProductKeys?: PendingOrderProductKeys,
  ) {
    if (hasOrderProductPendency(op, pendingOrderProductKeys)) {
      this.addToSectionWithErrors(op);
    } else {
      this.addToSectionWithoutErrors(op);
    }
  }

  private addToSectionWithErrors(op: OrderProduct) {
    this.sectionWithErrors.products.push(op);
    this.sectionWithErrors.productsCount += 1;
  }

  private addToSectionWithoutErrors(op: OrderProduct) {
    this.sectionWithoutErrors.products.push(op);
    this.sectionWithoutErrors.productsCount += 1;
  }

  private getSections() {
    if (this.sectionWithErrors.productsCount === 0) {
      return [this.sectionWithoutErrors];
    }
    if (this.sectionWithoutErrors.productsCount === 0) {
      return [this.sectionWithErrors];
    }
    return [this.sectionWithErrors, this.sectionWithoutErrors];
  }
}

export default OrderProductsGroupByPendency;
